import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
import mixin from '../mixin'; // client js begin

import VftQrcode from '@tencent/vft-ui/src/Qrcode'; // client js end

import util from '../../../util'; // Vue.use(Qrcode)

export default {
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    paramsObj: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    isQrCodeTag: function isQrCodeTag() {
      // 客户端 并且是 非短链
      return !this.isSSR && this.item.isQrCode && !this.item.isShortUrl;
    },
    realText: function realText() {
      var text = util.replaceParams(this.item.text, this.paramsObj);
      return this.isSSR ? util.filterText(text) : text;
    },
    realSrc: function realSrc() {
      var src = util.replaceParams(this.item.src, this.paramsObj); // 二维码（ssr 和 短链的）走 pay域名

      return this.item.isQrCode && (this.isSSR || this.item.isShortUrl) ? "https://vip.video.qq.com/fcgi-bin/comm_cgi?name=short_url&url=".concat(encodeURIComponent(src)).concat(this.item.isShortUrl ? '&need_short_url=1' : '', "&need_qrcode=1") : src;
    },
    imgStyleObj: function imgStyleObj() {
      return {
        width: this.item.width + 'px',
        height: this.item.height + 'px',
        display: 'block'
      };
    },
    styleObj: function styleObj() {
      var base = {
        width: this.item.width + 'px',
        height: this.item.height + 'px'
      };
      base.position = 'absolute';
      base.left = this.item.x + 'px';
      base.top = this.item.y + 'px';
      return Object.assign(base, util.getStyleObj(this.item.style) || {});
    },
    isSSR: function isSSR() {
      var vm = this;

      while (vm && vm.$options.name !== 'CloudSealCard') {
        vm = vm.$parent;
      }

      return vm.isSSR;
    }
  },
  methods: {
    getChildNode: function getChildNode() {
      var vm = this;
      var item = this.item;
      return {
        style: vm.imgStyleObj,
        attrs: {
          'data-content-type': item.zip && item.zip > 0 ? 'image/jpeg' : '',
          'data-zip': item.zip && item.zip > 0 ? item.zip : '',
          src: vm.removeHttp(vm.realSrc)
        }
      };
    },
    getVNode: function getVNode() {
      var vm = this;
      var item = this.item;
      var type = item.type;
      var obj = {
        class: [item.className],
        attrs: {
          id: item.id
        },
        style: vm.styleObj
      };

      if (type === 'text') {
        obj.domProps = {
          innerHTML: vm.realText
        };
      }

      return obj;
    }
  },
  render: function render(h) {
    var item = this.item;
    return h('div', this.getVNode(), item.type === 'img' ? [this.isQrCodeTag ? h('VftQrcode', {
      style: this.imgStyleObj,
      props: {
        options: {
          correctLevel: 1
        },
        url: this.realSrc
      }
    }) : h('img', this.getChildNode())] : []);
  },
  components: {
    // client js begin
    VftQrcode: VftQrcode // client js end

  }
};